// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__WGdpO","containerInner":"Profile_containerInner__lfFKp","tabs":"Profile_tabs__cRHg2"};